"use strict";
/**
 *  Export all the shared types of the CCOS API, which are used
 *  by the API, the tool and in the future the backoffice
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./types/map"), exports);
__exportStar(require("./types/pagination"), exports);
// Models
__exportStar(require("./types/models/accessory"), exports);
__exportStar(require("./types/models/address"), exports);
__exportStar(require("./types/models/brand"), exports);
__exportStar(require("./types/models/client"), exports);
__exportStar(require("./types/models/color"), exports);
__exportStar(require("./types/models/company"), exports);
__exportStar(require("./types/models/energy-label"), exports);
__exportStar(require("./types/models/entity"), exports);
__exportStar(require("./types/models/filter-technology"), exports);
__exportStar(require("./types/models/floor"), exports);
__exportStar(require("./types/models/image"), exports);
__exportStar(require("./types/models/indoor-unit"), exports);
__exportStar(require("./types/models/indoor-unit-location"), exports);
__exportStar(require("./types/models/insulation-level"), exports);
__exportStar(require("./types/models/link"), exports);
__exportStar(require("./types/models/minimum-waiting-time"), exports);
__exportStar(require("./types/models/offer-request"), exports);
__exportStar(require("./types/models/outdoor-unit"), exports);
__exportStar(require("./types/models/outdoor-unit-location"), exports);
__exportStar(require("./types/models/price-setting"), exports);
__exportStar(require("./types/models/product"), exports);
__exportStar(require("./types/models/product-line"), exports);
__exportStar(require("./types/models/roomsize"), exports);
__exportStar(require("./types/models/space"), exports);
__exportStar(require("./types/models/system"), exports);
/** Request typings */
__exportStar(require("./types/requests/from-spaces.request"), exports);
/* Response typings */
__exportStar(require("./types/responses/api.response"), exports);
__exportStar(require("./types/responses/api-error.response"), exports);
__exportStar(require("./types/responses/api-paginated.response"), exports);
__exportStar(require("./types/responses/api-map.response"), exports);
__exportStar(require("./types/responses/api-paginated-map.response"), exports);
__exportStar(require("./types/responses/api-single.response"), exports);
__exportStar(require("./types/responses/from-spaces.response"), exports);
//# sourceMappingURL=index.js.map